exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body-main[data-v-3ac86522]{position:relative;padding:0 15px}", ""]);

// exports
